import React from 'react';
import AdvancedVideoHero from '../components/AdvancedVideoHero';
import LogoSlider from '../components/LogoSlider';
import FoundersSection from '../components/FoundersSection';
import ServicesSection from '../components/ServicesSection';
import './Pages.css';

const Home = () => {
  return (
    <div className="page home-page">
      <AdvancedVideoHero
        sources={[
          { src: "/assets/videos/hero-video-home.mp4", type: "video/mp4" }
        ]}
        title="Bildung für morgen gestalten"
        subtitle="Wir befähigen Menschen und Organisationen, technologische und gesellschaftliche Veränderungen aktiv mitzugestalten."
        showOverlayControls={false}
        data-section="home-hero"
      />

      <LogoSlider />

      <FoundersSection />

      <ServicesSection />
      
      <section className="cta-section" data-section="home-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Gemeinsam Bildung für morgen gestalten.</h2>
            <p>Vereinbaren Sie ein unverbindliches Gespräch mit uns.</p>
            <a href="/kontakt" className="btn btn-secondary">Kontakt</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
